export class Exchange {
  _id?: string;
  EGP?: number;
  EUR?: number;
  SAR?: number;
  AED?: number;
  status?: string;
  createdAt?: string;
}
export enum Currency {
  USD = "USD",
  EGP = "EGP",
  EUR = "EUR",
  SAR = "SAR",
  AED = "AED",
  INR = "INR",
  BHD = "BHD",
  KWD = "KWD",
  QAR = "QAR",
  ZAR = "ZAR",
  TRY = "TRY",
}
export enum CurrencyWallets {
  ALL = "",
  USD = "USD",
  EGP = "EGP",
  EUR = "EUR",
  SAR = "SAR",
  AED = "AED",
  INR = "INR",
  BHD = "BHD",
  KWD = "KWD",
  QAR = "QAR",
  ZAR = "ZAR",
  TRY = "TRY",
}
export enum Rank {
  'All' = "",
  Normal = "Normal",
  Silver = "Silver",
  Gold = "Gold",
  Diamond = "Diamond",
}
export enum Role {
  'All' = '',
  USER = 'USER',
  ADMIN = 'ADMIN',
  'EMPLOYER-I' = "EMPLOYER-I",
  'EMPLOYER-II' = "EMPLOYER-II",
  'EMPLOYER-III' = "EMPLOYER-III",
}

